import { TColorKey } from '~theme/typings'
import { TSingleSpace } from '~ui/styleGuide/spaces'

const contentBg: TColorKey = `bgColors.primary`
const topCardsGap: TSingleSpace = `large`
const topCardsMarginBottom: TSingleSpace = `large`

// to synchronize category heading padding with padding of products in the list
// and also a product list with category buttons on mobile and tablet
const productPadding: TSingleSpace = `medium`

const mobileStickyCardHeightRem = 4.3
// currently in tablet is no sticky top card
const tabletStickyCardHeightRem = 0

// to synchronize and calculate mobile product heading height in order to manage its sticky position
const defaultTextLineHeight = 1.15

/**
 * values used to style different menu screen components,
 * they are kept here to remain in one place
 */
export const menuScreenLayoutSettings = {
  contentBg,
  topCardsGap,
  productPadding,
  defaultTextLineHeight,
  mobileStickyCardHeightRem,
  tabletStickyCardHeightRem,
  topCardsMarginBottom,
}
